/* ════════════════════════════════════════════════════════════
   VELVET RITUALS — About page behaviour
   assets/vr-about.js

   1. Scroll reveal for .vrab-r (spring pattern shared with the
      other custom pages).
   2. Word splitter for [data-vrab-words] headlines — wraps each
      word so it can rise line-masked on reveal.
   3. Parallax drift for [data-vrab-parallax] (hero watermark).
   4. Spine progress for [data-vrab-spine] — sets --vrab-p 0..1
      as the ecosystem thread scrolls through the viewport.

   Self-guards so multiple section includes run it once, and
   re-arms after theme-editor re-renders.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__vrAboutInit) return;
  window.__vrAboutInit = true;

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Word splitter ─────────────────────────────────────── */
  var splitWords = function (scope) {
    var els = (scope || document).querySelectorAll('[data-vrab-words]:not(.split)');
    els.forEach(function (el) {
      el.classList.add('split');
      if (reduced) return;
      var i = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) {
                frag.appendChild(document.createTextNode(part));
                return;
              }
              var w = document.createElement('span');
              w.className = 'vrab__w';
              var inner = document.createElement('span');
              inner.textContent = part;
              inner.style.setProperty('--i', i++);
              w.appendChild(inner);
              frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            walk(child);
          }
        });
      };
      walk(el);
    });
  };

  /* ── Scroll reveal ─────────────────────────────────────── */
  var arm = function (scope) {
    splitWords(scope);
    var els = (scope || document).querySelectorAll('.vrab-r:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };

  /* ── Parallax + spine progress (one rAF loop) ──────────── */
  var ticking = false;
  var frame = function () {
    ticking = false;
    var vh = window.innerHeight;

    document.querySelectorAll('[data-vrab-parallax]').forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-vrab-parallax')) || 0.15;
      var r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      var offset = (vh / 2 - (r.top + r.height / 2)) * speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    });

    document.querySelectorAll('[data-vrab-spine]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (vh * 0.72 - r.top) / r.height;
      p = Math.max(0, Math.min(1, p));
      el.style.setProperty('--vrab-p', p.toFixed(3));
    });
  };
  var onScroll = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  };

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {
    arm(document);
    if (!reduced) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    } else {
      /* spine fully drawn when motion is reduced */
      document.querySelectorAll('[data-vrab-spine]').forEach(function (el) {
        el.style.setProperty('--vrab-p', '1');
      });
    }
  });
  document.addEventListener('shopify:section:load', function (e) {
    arm(e.target);
    onScroll();
  });
})();
